// The only runtime signal of the deployed environment: VITE_SENTRY_ENVIRONMENT
// is injected per GitLab environment (staging / release / production).
// Falls back to MODE, which is "production" for any build — so a missing
// variable hides environment-gated tooling rather than exposing it.
export const appEnvironment =
  import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE;

export const isProductionEnvironment = appEnvironment === "production";
